var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showApplicationLoader, hideApplicationLoader, } from 'common/ApplicationLoader';
import { Roles } from 'globals/enums';
import { getCareAgentService, getCareAgentServiceAdmin, getNewCareAgentServiceAdmin, } from 'services/careAgentAccountService/careAgentAccount.service';
import { showError } from 'store/commonReducer/common.action';
export var GET_CARE_AGENT_LIST = 'GET_CARE_AGENT_LIST';
export var GET_ACCOUNT_PAGE_LIST = 'GET_ACCOUNT_PAGE_LIST';
export var GET_CARE_AGENT_LIST_SUCCESS = 'GET_CARE_AGENT_LIST_SUCCESS';
export var GET_ACCOUNTS_LIST_SUCCESS = 'GET_ACCOUNTS_LIST_SUCCESS';
export var GET_ACCOUNTS_LIST_SUCCESS_OFFSET = 'GET_ACCOUNTS_LIST_SUCCESS_OFFSET';
export var GET_CARE_AGENT_LIST_SORT = 'GET_CARE_AGENT_LIST_SORT';
export var GET_CW_ACCOUNT_LIST_SORT = 'GET_CW_ACCOUNT_LIST_SORT';
export var GET_CARE_AGENT_LIST_FAIL = 'GET_CARE_AGENT_LIST_FAIL';
export var GET_ACCOUNTS_LIST_FAIL = 'GET_ACCOUNTS_LIST_FAIL';
export var UPDATE_CARE_AGENT_LIST_PAGE_NUMBER = 'UPDATE_CARE_AGENT_LIST_PAGE_NUMBER';
export var UPDATE_ACCOUNTS_LIST_PAGE_NUMBER = 'UPDATE_ACCOUNTS_LIST_PAGE_NUMBER';
export var RESET_CARE_AGENT_LIST = 'RESET_CARE_AGENT_LIST';
export var RESET_CW_ACCOUNT_LIST = 'RESET_CW_ACCOUNT_LIST';
export var GET_CARE_AGENT_SEARCH_LIST_SUCCESS = 'GET_CARE_AGENT_SEARCH_LIST_SUCCESS';
export var GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS = 'GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS';
export var GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS_OFFSET = 'GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS_OFFSET';
export var SET_ADMIN_ACCOUNT_QUERY_PARAMS = 'SET_ADMIN_ACCOUNT_QUERY_PARAMS';
export var GET_COMMUNITY_AGENT_SEARCH_LIST = 'GET_COMMUNITY_AGENT_SEARCH_LIST';
export var GET_CARE_AGENT_SEARCH_LIST = 'GET_CARE_AGENT_SEARCH_LIST';
export var GET_CARE_AGENT_SEARCH_MEMBER = 'GET_CARE_AGENT_SEARCH_MEMBER';
export var GET_ADMIN_ACCOUNT_SEARCH = 'GET_ADMIN_ACCOUNT_SEARCH';
export var GET_CARE_AGENT_SEARCH_LOCATION = 'GET_CARE_AGENT_SEARCH_LOCATION';
export var SET_CW_MEMBER_ACCOUNT_FILTER_STATUS = 'SET_CW_MEMBER_ACCOUNT_FILTER_STATUS';
export var SET_CARE_AGENT_LIST_PARAMS = 'SET_CARE_AGENT_LIST_PARAMS';
export var getCareAgentList = function (searchQuery, lastEvaluatedKey, showLoader, shift, role, checkFilterMethod) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    if (shift === void 0) { shift = []; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchQuery !== '' && !(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.trim())) {
                        return [2 /*return*/, { data: [], lastEvaluatedKey: '' }];
                    }
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    dispatch({ type: GET_CARE_AGENT_LIST });
                    params = {};
                    // if (lastEvaluatedKey) {
                    //   params.last_evaluated_key = lastEvaluatedKey;
                    // }
                    if (searchQuery) {
                        if (checkFilterMethod == "member_id") {
                            params.search_query = JSON.stringify([
                                { type: 'member_id', value: searchQuery },
                            ]);
                        }
                        else {
                            params.search_query = JSON.stringify([
                                { type: 'name', value: searchQuery },
                            ]);
                        }
                    }
                    // if (shift.length) {
                    //   params.shift = JSON.stringify(shift);
                    // }
                    if (role) {
                        params.role = role;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCareAgentService(params)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response === null || response === void 0 ? void 0 : response.result,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_1 = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCareAgentList
 * @description action creator to get CareAgent List
 * @param {string} searchQuery
 * @param {any} lastEvaluatedKey
 * @param {boolean} showLoader if set true will show the ApplicationLoader
 * @param {ShiftTypes[]} shift an array of shifts to filter
 * @param {Roles} role role to filter
 */
export var getCareAgentListHome = function (searchQueryCoach, searchQuery, lastEvaluatedKey, showLoader, role, checkFilterMethod, shift, assigned_senior, location) {
    if (searchQueryCoach === void 0) { searchQueryCoach = ''; }
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var shiftValue, assignedValue, searchLocation, searchQueryCoach, params, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if (searchQuery !== '' && !searchQuery?.trim()) {
                    //   return {data: [], lastEvaluatedKey: ''};
                    // }
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    dispatch({ type: GET_CARE_AGENT_LIST });
                    shiftValue = getState().corporateAndFacilities.careAgents.shiftFilter;
                    assignedValue = getState().corporateAndFacilities.careAgents.assignFilter;
                    searchLocation = getState().common.careAgentList.searchQueryLocation;
                    searchQueryCoach = getState().common.careAgentList.searchQuery;
                    params = {};
                    // if (lastEvaluatedKey) {
                    //   params.last_evaluated_key = lastEvaluatedKey;
                    // }
                    if (searchQueryCoach) {
                        params.search_query = JSON.stringify([{ type: 'name', value: searchQueryCoach }]);
                    }
                    if (searchLocation) {
                        params.location = searchLocation;
                    }
                    if (role) {
                        params.role = role;
                    }
                    if (shiftValue) {
                        params.shift = [shiftValue];
                    }
                    if (assignedValue) {
                        params.assigned_senior = [assignedValue];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCareAgentService(params)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response === null || response === void 0 ? void 0 : response.result,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_2 = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCareAgentListAdmin
 * @description action creator to get CareAgent List
 * @param {string} searchQuery
 * @param {any} lastEvaluatedKey
 * @param {boolean} showLoader if set true will show the ApplicationLoader
 * @param {ShiftTypes[]} shift an array of shifts to filter
 * @param {Roles} role role to filter
 */
export var getCareAgentListAdmin = function (searchQuery, lastEvaluatedKey, showLoader, shift, status, role, checkFilterMethod) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    if (shift === void 0) { shift = []; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var status, role, search, searchMember, isFirstLogin, isActive, accountStatusFilter, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchQuery !== '' && !(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.trim())) {
                        return [2 /*return*/, { data: [], lastEvaluatedKey: '' }];
                    }
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    dispatch({ type: GET_CARE_AGENT_LIST });
                    status = getState().corporateAndFacilities.careAgents.statusFilter;
                    role = getState().corporateAndFacilities.careAgents.roleFilter;
                    search = getState().common.careAgentList.searchQuery;
                    searchMember = getState().common.careAgentList.searchQueryMember;
                    isFirstLogin = null;
                    if (status === 'Inactive') {
                        isFirstLogin = true;
                    }
                    else if (status === 'Active') {
                        isFirstLogin = false;
                    }
                    isActive = null;
                    accountStatusFilter = getState().corporateAndFacilities.careAgents.accountStatusFilter;
                    if (accountStatusFilter === 'Enabled') {
                        isActive = true;
                    }
                    else if (accountStatusFilter === 'Disabled') {
                        isActive = false;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCareAgentServiceAdmin(search, searchMember, role, isFirstLogin, isActive)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response === null || response === void 0 ? void 0 : response.result,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_3 = _a.sent();
                    dispatch(showError(error_3));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCWAccountListAdmin
 * @description action creator to get CareAgent List
 */
export var getCWAccountListAdmin = function (accountKey) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var filters, accountStatusFilter, status, role, search, searchMember, isFirstLogin, isActive, response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showApplicationLoader());
                    dispatch({ type: GET_ACCOUNT_PAGE_LIST, payload: accountKey });
                    filters = getState().common.accounts[accountKey].queryParams;
                    sessionStorage.setItem("".concat(accountKey, "Filters"), JSON.stringify(filters));
                    accountStatusFilter = filters.accountStatusFilter, status = filters.statusFilter, role = filters.roleFilter, search = filters.nameFilter, searchMember = filters.employeeIdFilter;
                    isFirstLogin = null;
                    if (status === 'Inactive') {
                        isFirstLogin = true;
                    }
                    else if (status === 'Active') {
                        isFirstLogin = false;
                    }
                    isActive = null;
                    if (accountStatusFilter === 'Enabled') {
                        isActive = true;
                    }
                    else if (accountStatusFilter === 'Disabled') {
                        isActive = false;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCareAgentServiceAdmin(search, searchMember, role, isFirstLogin, isActive)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response === null || response === void 0 ? void 0 : response.result,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_4 = _a.sent();
                    dispatch(showError(error_4));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getNewCWAccountListAdmin = function (accountKey) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var filters, accountStatusFilter, status, role, search, isFirstLogin, isActive, response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // dispatch(showApplicationLoader());
                    dispatch({ type: GET_ACCOUNT_PAGE_LIST, payload: accountKey });
                    filters = getState().common.accounts[accountKey].queryParams;
                    sessionStorage.setItem("".concat(accountKey, "Filters"), JSON.stringify(filters));
                    accountStatusFilter = filters.accountStatusFilter, status = filters.statusFilter, role = filters.roleFilter, search = filters.searchFilter;
                    isFirstLogin = null;
                    if (status === 'Inactive') {
                        isFirstLogin = true;
                    }
                    else if (status === 'Active') {
                        isFirstLogin = false;
                    }
                    isActive = null;
                    if (accountStatusFilter === 'Enabled') {
                        isActive = true;
                    }
                    else if (accountStatusFilter === 'Disabled') {
                        isActive = false;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getNewCareAgentServiceAdmin(search, role, isFirstLogin, isActive)];
                case 2:
                    response = _a.sent();
                    // dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response === null || response === void 0 ? void 0 : response.result,
                            lastEvaluatedKey: response === null || response === void 0 ? void 0 : response.lastEvaluatedKey,
                        }];
                case 3:
                    error_5 = _a.sent();
                    dispatch(showError(error_5));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCareAgentListWithoutOvernight
 * @description action creator to get CareAgent List without shift Overnight
 * @param {string} searchQuery
 * @param {any} lastEvaluatedKey
 * @param {boolean} showLoader if set true will show the ApplicationLoader
 */
export var getCareAgentListWithoutOvernight = function (searchQueryCoach, searchQuery, lastEvaluatedKey, showLoader, checkFilterMethod, shift, assigned_senior, location) {
    if (searchQueryCoach === void 0) { searchQueryCoach = ''; }
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    if (checkFilterMethod === void 0) { checkFilterMethod = ''; }
    return getCareAgentListHome(searchQueryCoach, searchQuery, lastEvaluatedKey, showLoader, Roles.CareAgent, checkFilterMethod, shift, assigned_senior, location);
};
/**
 * @function getCareAgentListSuccess
 * @description action creator to store careAgents table data
 * @param tableData
 */
export var getCareAgentListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey, searchLastEvaluatedKey = tableData.searchLastEvaluatedKey;
    dispatch({
        type: GET_CARE_AGENT_LIST_SUCCESS,
        payload: {
            data: data,
            lastEvaluatedKey: lastEvaluatedKey,
            searchLastEvaluatedKey: searchLastEvaluatedKey,
        },
    });
}; };
/**
 * @function getAccountsListSuccess
 * @description action creator to store accounts section table data
 * @param tableData
 * @param accountKey to identify the page
 */
export var getAccountsListSuccess = function (tableData, accountKey) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey, searchLastEvaluatedKey = tableData.searchLastEvaluatedKey;
    dispatch({
        type: GET_ACCOUNTS_LIST_SUCCESS,
        payload: {
            data: data,
            lastEvaluatedKey: lastEvaluatedKey,
            searchLastEvaluatedKey: searchLastEvaluatedKey,
            accountKey: accountKey,
        },
    });
}; };
/**
 * @function getAccountsListSuccessOffset
 * @description action creator to store accounts section table data
 * @param tableData
 * @param accountKey to identify the page
 */
export var getAccountsListSuccessOffset = function (tableData, offset, accountKey) {
    return function (dispatch) {
        dispatch({
            type: GET_ACCOUNTS_LIST_SUCCESS_OFFSET,
            payload: {
                data: tableData,
                offset: offset,
                accountKey: accountKey,
            },
        });
    };
};
/**
 * @function getCareAgentListSort
 * @description action creator to store careAgents table data
 * @param tableData
 */
export var getCareAgentListSort = function (tableData) { return function (dispatch) {
    dispatch({
        type: GET_CARE_AGENT_LIST_SORT,
        payload: {
            data: tableData,
        },
    });
}; };
/**
 * @function getCWAccountListSort
 * @description action creator to store cw Accounts table data
 * @param tableData
 */
export var getCWAccountListSort = function (tableData, accountKey) { return function (dispatch) {
    dispatch({
        type: GET_CW_ACCOUNT_LIST_SORT,
        payload: {
            data: tableData,
            accountKey: accountKey,
        },
    });
}; };
/**
 * @function getCareAgentSearchListSuccess
 * @description action creator to store careAgents table data
 * @param tableData
 */
export var getCareAgentSearchListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: GET_CARE_AGENT_SEARCH_LIST_SUCCESS,
        payload: {
            data: data,
            searchLastEvaluatedKey: lastEvaluatedKey,
        },
    });
}; };
/**
 * @function getAdminAccountSearchListSuccess
 * @description action creator to store careAgents table data
 * @param tableData
 * @param accountKey to identify the section under Admin -> Accounts
 */
export var getAdminAccountSearchListSuccess = function (tableData, accountKey) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS,
        payload: {
            data: data,
            searchLastEvaluatedKey: lastEvaluatedKey,
            accountKey: accountKey,
        },
    });
}; };
/**
 * @function getAdminAccountSearchListSuccessOffset
 * @description action creator to store careAgents table data
 * @param tableData
 * @param accountKey to identify the section under Admin -> Accounts
 */
export var getAdminAccountSearchListSuccessOffset = function (tableData, accountKey) { return function (dispatch) {
    dispatch({
        type: GET_ADMIN_ACCOUNT_SEARCH_LIST_SUCCESS_OFFSET,
        payload: {
            data: tableData,
            accountKey: accountKey,
        },
    });
}; };
/**
 * @function getCareAgentListFail
 * @description action creator to fetch error on api get fail
 * @param error
 */
export var getCareAgentListFail = function (error) { return function (dispatch) {
    dispatch(showError(error));
    dispatch({
        type: GET_CARE_AGENT_LIST_FAIL,
    });
}; };
/**
 * @function getAccountsListFail
 * @description action creator to fetch error on api get fail
 * @param error
 */
export var getAccountsListFail = function (error, accountKey) { return function (dispatch) {
    dispatch(showError(error));
    dispatch({
        type: GET_CARE_AGENT_LIST_FAIL,
        payload: accountKey,
    });
}; };
/**
 * @function updateCareAgentListPageNumber
 * @description action creator to update the page number of careAgents table
 * @param {string | number} value
 */
export var updateCareAgentListPageNumber = function (value) { return function (dispatch) {
    dispatch({ type: UPDATE_CARE_AGENT_LIST_PAGE_NUMBER, payload: value });
}; };
/**
 * @function updateAccountsListPageNumber
 * @description action creator to update the page number of accounts table
 * @param {string | number} value
 */
export var updateAccountsListPageNumber = function (value, accountKey) { return function (dispatch) {
    if (!value || isNaN(value))
        return;
    dispatch({ type: UPDATE_ACCOUNTS_LIST_PAGE_NUMBER, payload: {
            pageNumber: value,
            accountKey: accountKey,
        } });
}; };
/**
 * @function resetCareAgentList
 * @description action creator to reset careAgents table
 */
export var resetCareAgentList = function () { return function (dispatch) {
    dispatch({
        type: RESET_CARE_AGENT_LIST,
    });
}; };
/**
 * @function resetCWAccountList
 * @description action creator to reset CW Accounts table (Under Admin -> Accounts -> CW)
 */
export var resetCWAccountList = function (accountKey) { return function (dispatch) {
    dispatch({
        type: RESET_CW_ACCOUNT_LIST,
        payload: accountKey
    });
}; };
/**
 * @description search careAgent by name
 * @function searchCareAgentByName
 * @param {any[]} data
 * @param {string} searchQuery
 * @returns {any[]}
 */
export var searchCareAgentByName = function (data, searchQuery) {
    if (data === void 0) { data = []; }
    if (searchQuery === void 0) { searchQuery = ''; }
    return data.filter(function (careAgent) {
        var _a;
        var basicInfo = careAgent.name;
        var query = searchQuery.toLowerCase().split(' ');
        var firstName = basicInfo.firstName.toLowerCase() || '';
        var middleName = ((_a = basicInfo.middleName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
        var lastName = basicInfo.lastName.toLowerCase() || '';
        return query.every(function (data) {
            return (firstName.includes(data) ||
                middleName.includes(data) ||
                lastName.includes(data));
        });
    });
};
